import type { Table } from "dexie";
import Dexie from "dexie";
import "dexie-observable";
import { devLogger } from "@certa/common/utils/devLogger";
import { isDev } from "@certa/common/utils/isDev";
import type { MegaJSON } from "@certa/studio-core";

class StudioDB extends Dexie {
  // 'friends' is added by dexie when declaring the stores()
  // We just tell the typing system this is the case
  megaJSON!: Table<MegaJSON>;

  constructor() {
    super("certa-studio-preview");

    /** Version history
     * 1: Initial Version
     * 2: Added undoStack and redoStack tables
     * 3: Added createdAt, modifiedAt timestamps migration
     * 4: Added "metajson" table for in memory metajson implementation
     * 5: Removed other tables, only "metajson" table is used
     */

    this.version(6).stores({
      megaJSON: "&id"
    });
  }
}

export const db = new StudioDB();

// DatabaseClosed error is a unhandled Dexie error which can happen due to the following
// 1. Browser Storage Limits
// 2. Manual Database Closure using db.close() and then performing an operation
// 3. Multiple tab scenarios: If one tab is performing an version upgrade. Ongoing operations in other tabs will fail with DatabaseClosedError
if (isDev) {
  window.addEventListener("unhandledrejection", event => {
    if (event.reason?.name === "DatabaseClosedError") {
      devLogger.error(
        "Dexie DatabaseClosedError occurred:",
        JSON.stringify(event.reason, null, 2)
      );
    }
  });
}
